module.exports = __webpack_public_path__ + "img/7.09bcb235.jpg";